// 组件埋点相关数据

export function expoComponent(iquicInfo, extInfo) {
  try {
    window.iTracert.expoComponent(iquicInfo, extInfo);
  } catch (err) {
    console.log(err);
  }
}
export function expoNode(iquicInfo, nodeName, hasIndex, extInfo) {
  try {
    window.iTracert.expoNode(iquicInfo, nodeName, hasIndex, extInfo);
  } catch (err) {
    console.log(err);
  }
}
export function clickNode(iquicInfo, nodeName, hasIndex, extInfo) {
  try {
    window.iTracert.clickNode(iquicInfo, nodeName, hasIndex, extInfo);
  } catch (err) {
    console.log(err);
  }
}
